import { createAsyncThunk, createReducer } from '@reduxjs/toolkit'
import { API, SCOPE_SUBCONTRACTOR_FORMS } from '../../constants'
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common'
import {
  extendListBuilder,
  generateListActions,
} from '../helpers/listActionsHelpers'
import { application } from '../../services/application'
import { ANY_OF_THOSE, CONTAINS, IS_BETWEEN } from '../../constants/filter'

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['createdAt', 'desc'],
  subcontractorFormDetail: null,
  subcontractorFormReplies: [],
  repliesPending: false,
  filters: {
    ...INITIAL_LIST_STATE_EXTENDED.filters,
    fields: {
      ...INITIAL_LIST_STATE_EXTENDED.filters.fields,
      adminStatus: {
        type: ANY_OF_THOSE,
        value: ['new', 'progress', 'completed'],
      },
      organizationName: {
        type: CONTAINS,
        value: '',
      },
      updatedAt: {
        type: IS_BETWEEN,
        value: {
          from: null,
          to: null,
        },
      },
    },
  },
  params: {
    onlySubcontractorForms: true,
  },
}

//Actions
const listActions = generateListActions({
  scope: SCOPE_SUBCONTRACTOR_FORMS,
  apiMethod: {
    GET_LIST: API.SUBCONTRACTOR_FORMS.GET_LIST,
  },
  getStore: store => store.subcontractorForms,
})

const getReplies = createAsyncThunk(
  'subcontractorForms/getReplies',
  params => {
    return application.call(API.SUBMITTED_FORMS.GET_REPLIES, params)
  }
)
function onGetReplies(state, action) {
  Object.assign(state, {
    subcontractorFormReplies: action.payload.data.replies || [],
    repliesPending: false,
  })
}
function onGetRepliesPending(state) {
  Object.assign(state, {
    repliesPending: true,
  })
}

const createReply = createAsyncThunk(
  'subcontractorForms/createReply',
  params => {
    return application.call(API.SUBMITTED_FORMS.CREATE_REPLY, params)
  }
)
function onCreateReply(state, action) {
  const newReply = action.payload.organizationFormReply
  if (newReply) {
    const updatedReplies = [...state.subcontractorFormReplies, newReply]
    Object.assign(state, {
      subcontractorFormReplies: updatedReplies,
    })
  }
}

const assignUser = createAsyncThunk('subcontractorForms/assignUser', params => {
  return application.call(API.SUBMITTED_FORMS.ASSIGN_USER, params)
})

const getStaffUsers = createAsyncThunk('subcontractorForms/getStaffUsers', () => {
  return application.call(API.SUBMITTED_FORMS.GET_STAFF_USERS)
})
function onGetStaffUsers(state, action) {
  Object.assign(state, {
    users: action.payload,
  })
}

const downloadFormPdf = createAsyncThunk('subcontractorForms/downloadFormPdf', params => {
  return application.call(API.SUBMITTED_FORMS.DOWNLOAD_FORM_PDF, params)
})

const assignFormToStaff = createAsyncThunk('subcontractorForms/assignFormToStaff', params => {
  return application.call(API.SUBMITTED_FORMS.ASSIGN_FORM_TO_STAFF, params)
})

const batchUpdateStatus = createAsyncThunk('subcontractorForms/batchUpdateStatus', params => {
  return application.call(API.SUBCONTRACTOR_FORMS.BATCH_UPDATE_STATUS, params)
})

const updateScore = createAsyncThunk('subcontractorForms/updateScore', params => {
  return application.call(API.SUBCONTRACTOR_FORMS.UPDATE_SCORE, params)
})

export const actions = {
  ...listActions,
  getReplies,
  createReply,
  assignUser,
  getStaffUsers,
  downloadFormPdf,
  assignFormToStaff,
  batchUpdateStatus,
  updateScore,
}

export default createReducer(INITIAL_STATE, builder => {
  return extendListBuilder(builder, actions)
    .addCase(getReplies.pending, onGetRepliesPending)
    .addCase(getReplies.fulfilled, onGetReplies)
    .addCase(createReply.fulfilled, onCreateReply)
    .addCase(getStaffUsers.fulfilled, onGetStaffUsers)
})
